import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const itemCarouselSlice = createSelector(stateSelector, (state) => state.itemCarousel);

const idSelector = (_, id: number) => id;

const byIdSelector = createSelector(itemCarouselSlice, (state) => state.byId);
const loadedSelector = createSelector(itemCarouselSlice, (state) => state.loaded);

export const getCarousels = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || []);

export const getIsItemCarouselLoading = createSelector(itemCarouselSlice, (state) => state.loading);

export const getIsItemCarouselLoaded = createSelector([loadedSelector, idSelector], (loaded, id) =>
    loaded.hasOwnProperty(id)
);

export const shouldFetchCarousel = createSelector(
    [itemCarouselSlice, idSelector],
    (state, key) => key > 0 && !state.loaded.hasOwnProperty(key) && !state.loading
);
